{
  "loading": "Loading...",
  "error": "An error occurred",
  "save": "Save",
  "cancel": "Cancel",
  "back": "Back",
  "success": "Success",
  "info": "Info",
  "ok": "OK",
  "skip": "Skip for now",
  "later": "Later",
  "update_now": "Update now",
  "update_available_title": "Update available",
  "update_available_message": "Version {{latestVersion}} is available. You are using {{currentVersion}}.",
  "failed_to_save_language": "Failed to save language preference.",
  "logo_accessibility": "Vocalise logo",
  "page_title_app": "Vocalise",
  "page_title_onboarding": "Vocalise Onboarding",
  "page_title_create_account": "Vocalise Create Account",
  "page_title_purchase": "Vocalise Purchase",
  "page_title_voucher": "Vocalise Voucher",
  "page_title_settings": "Vocalise Settings",
  "page_title_session": "Vocalise Session",
  "page_title_preview_session": "Vocalise Preview Session",
  "page_title_library": "Vocalise Library",
  "page_title_dashboard": "Vocalise Dashboard",
  "page_title_statistics": "Vocalise Statistics",
  "page_title_report_issue": "Vocalise Report Issue",
  "sentry_error_title": "Something went wrong",
  "sentry_error_message": "An unexpected error occurred.",
  "sentry_error_report_issue": "Add details to report",
  "error_try_again": "Try Again",
  "error_sign_out": "Sign Out",
  "error_go_back": "Go back",
  "toast_dismiss_a11y": "Dismiss toast",
  "toast_retry": "Retry",
  "session_expired_title": "Session expired",
  "session_expired_message": "Please sign in again to continue.",
  "session_expired_continue": "Continue to sign in",
  "callback_completing_sign_in": "Completing sign in…",
  "beta_badge_label": "Beta",
  "beta_badge_accessibility_label": "You are currently testing our future functionality. Errors may occur."
}
